import Children from '../../../layouts/Children';

const routes = [
  {
    path: 'request-vacations',
    component: Children,

    children: [
      {
        path: '',
        name: 'request-vacations',
        component: () => import('../pages/RequestVacationsPage.vue')
      }
    ]
  }
];

export default routes;
